var FormModalFactory = function ($uibModal, jsonrpc) {
    var m = {};


    m.open = function (name, params, extend_model, modal_config, $scope) {
        var api_service = name.split('.')[0];
        var api_method = name.split('.')[1];
        var FormsApiService = jsonrpc.newService(api_service).createMethod(api_method);

        var new_modal_config = angular.extend(
            {
                animation: false,
                keyboard: true,
                backdrop: 'static',
                windowClass: 'amt-modal-max-width',
                templateUrl: 'amt.forms/modal.html',
                scope: $scope
            },
            modal_config || {},
            {
                resolve: {
                    schema_form: function () {
                        return FormsApiService({'action': 'get', 'params': params || {}, 'model': {}})
                    }
                },
                controller: ['$scope', '$uibModalInstance', '$q', '$timeout', 'schema_form',
                    function ($scope, $uibModalInstance, $q, $timeout, schema_form) {
                        $scope.title = schema_form.model._form_title || schema_form.schema.title;
                        $scope.description = schema_form.model._form_description || schema_form.schema.description;
                        $scope.schema_form = schema_form;
                        $scope.extend_model = extend_model;

                        $scope.onSubmit = function (form, model) {
                            $scope.$broadcast('schemaFormValidate');
                            if (form.$valid) {
                                FormsApiService({'action': 'submit', 'model': model, 'params': params || {}})
                                    .then(
                                        function (resp) {
                                            $uibModalInstance.close(resp);
                                        },
                                        function (error) {

                                            $scope.$broadcast(
                                                'schemaForm.error.' + error.field_key,
                                                'serverValidation',
                                                error.message_text
                                            );
                                            $timeout(function () {
                                                    $scope.$broadcast(
                                                        'schemaForm.error.' + error.field_key,
                                                        'serverValidation',
                                                        true
                                                    );
                                            }, 2000)

                                        }
                                    )
                            }
                        };
                    }]
            }
        );
        var model_instance = $uibModal.open(new_modal_config);
        model_instance.rendered.then(function() {
            //
        });
        return model_instance.result
    };
    return m;
};

export default function (module) {
    module.factory('FormModalFactory', ['$uibModal', 'jsonrpc', FormModalFactory])
};
